import { render, staticRenderFns } from "./SyncDepartmentHods.vue?vue&type=template&id=51a2d6db"
import script from "./SyncDepartmentHods.vue?vue&type=script&lang=js"
export * from "./SyncDepartmentHods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports